import request from '../utils/request'
import requestUnique from '../utils/requestSSO'

export function loginEmail(data){
    return request({
        url:'/login/loginVerifyByEmail',
        method:'post',
        data:data
    })
}

export function loginphone(data){
    return request({
        url:'/login/loginVerifyByPhone',
        method:'post',
        data:data
    })
}

export function sendPhoneCode(data){
    return request({
        url:'/login/getVerifyPhoneCode',
        method:'post',
        data:data
    })
}

export function sendEmailCode(data){
    return request({
        url:'/login/getVerificationCode',
        method:'post',
        data:data
    })
}

export function resetPasseord(data){
    return request({
        url:'/login/resetPassword',
        method:'post',
        data:data
    })
}

export function registerEmail(data){
    return request({
        url:'/login/register',
        method:'post',
        data:data
    })
}

export function secrectLogin(data){
    return request({
        url:'/login/logonVerifyWithEmail',
        method:'post',
        data:data
    })
}

export function getgongyao(data){
    return request({
        url:'/login/getPublicKey',
        method:'get'
    })
}

export function loginwidthPublicKeyT(data){
    return request({
        url:'/login/loginVerifyForMobile',
        method:'post',
        data:data
    })
}

export function easyLoginByPhoneApi(data){
    return request({
        url:'/login/easyLoginByPhone',
        method:'post',
        data:data
    })
}

// sso
export function getSSOPublicKeyAPI(data){
    return requestUnique({
        url:'/lb-sso-api/public/getPublicKey',
        method:'get'
    })
}

export function ssologin(data){
    return requestUnique({
        url:'/lb-sso-api/customer/login',
        method:'post',
        data:data
    })
}

export function ssoSendcode(data){
    return requestUnique({
        url:'/lb-sso-api/sms/send',
        method:'post',
        data:data
    })
}

export function ssoRegister(data){
    return requestUnique({
        url:'/lb-sso-api/customer/register',
        method:'post',
        data:data
    })
}

export function ssoRegisterSendEmail(data){
    return requestUnique({
        url:'/lb-sso-api/email/send',
        method:'post',
        data:data
    })
}

export function ssoCheckEmailCodeApi(data){
    return requestUnique({
        url:'/lb-sso-api/email/checkEmailCode',
        method:'post',
        data:data
    })
}


export function ssoResetPWD(data){
    return requestUnique({
        url:'/lb-sso-api/password/resetPassword',
        method:'post',
        data:data
    })
}